import filter from './filter';
import list from './list';
import search from './search';
import map from './map';


export default function() {
	if ( document.getElementById('property-listing') ) {
		filter();
		list.load();
		map.setup();
	}
	search();
}
